export const testData = {
    data: [
        {
            _selected: false,
            list: [
                { val: "123123", type: "title", maxLength: 0 },
                { val: "Green", type: "string", maxLength: 0 },
                {
                    val: "Mon, 22 Nov 2021 04:36:59 GMT",
                    type: "time",
                    format: "date",
                    maxLength: 0,
                },
                {
                    val: [
                        { trg: "-10", state: 1 },
                        { trg: "0", state: 1 },
                        { trg: "20", state: 0 },
                    ],
                    type: "tripleCounter",
                    maxLength: 0,
                },
            ],
        },
        {
            _selected: false,
            list: [
                { val: "456456", type: "title", maxLength: 0 },
                { val: "Red", type: "string", maxLength: 0 },
                {
                    val: "Mon, 22 Nov 2021 04:36:59 GMT",
                    type: "time",
                    format: "date",
                    maxLength: 0,
                },
                {
                    val: [
                        { trg: "-10", state: 1 },
                        { trg: "0", state: 2 },
                        { trg: "20", state: 0 },
                    ],
                    type: "tripleCounter",
                    maxLength: 0,
                },
            ],
        },
    ]
};
export const testHeader = {
    data: [
        { name: "Name", type: "title" },
        { name: "Atr_A", type: "string" },
        { name: "Atr_B", type: "time" },
        { name: "Counter", type: "tripleCounter" },
    ]
};
export const HeadderConfig = {
    data: [
        { name: "Číslo KLT", type: "title" },
        { name: "HW-ID", type: "title" },
        { name: "Objednávka", type: "string" },
        { name: "Zástupce objednavatele", type: "string", visible: false },
        { name: "Objednavatel", type: "string", visible: false },
        { name: "Zástupce příjemce", type: "string", visible: false },
        { name: "Příjemce", type: "string" },
        { name: "Založeno", type: "time", width: 'autoSpace' },
        { name: "Stav Protokolu", type: "mesState", width: 'autoSpace' },
        { name: "Stav Kalibrace", type: "tripleCounter", width: 'auto' },
    ]
};
export function parseToTable(mesurmnetList) {
    if (!mesurmnetList) {
        return {
            data: []
        };
    }
    return {
        data: mesurmnetList.map(mes => {
            return {
                list: [
                    { val: mes.static.id },
                    { val: mes.static.probe.id },
                    { val: mes.static.orderNote },
                    { val: mes.static.baseOwnerUser.name },
                    { val: mes.static.baseOwnerCom.name },
                    { val: mes.static.baseCustomeUser.name },
                    { val: mes.static.baseCustomeCom.name },
                    {
                        val: mes.static.createdTS.toString(),
                        format: 'date'
                    },
                    {
                        val: mes.dinamic.stage.key,
                        meta: mes.dinamic.stage.metaList
                    },
                    {
                        val: mes.static.targetDataPoints.map(dt => {
                            return {
                                temp: dt.temp,
                                state: dt.state
                            };
                        })
                    },
                ]
            };
        })
    };
}
